module.exports = __webpack_public_path__ + "img/advantage-img.73cae0b9.png";